export const getResourcePlacesSearch = async ({ accountId = window.currentAccountId, viewMode = ['Customer'], q, ids }) => {
  const query = new URLSearchParams();

  if (accountId) query.append('account_id', accountId);
  if (viewMode && Array.isArray(viewMode)) {
    viewMode.forEach(mode => query.append('view_mode[]', mode));
  }
  if (q) query.append('q', q);
  ids?.forEach(id => query.append('ids[]', id));

  const response = await fetch(`/resource_places?${query.toString()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    throw new TypeError("Resposta não é JSON!");
  }

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }
  
  return responseJson;
};


